import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { uploadImgOpcion, uploadImgCustom, guardaOpcion } from "../actions/admin";
import Switch from "../components/switch";
import AdminMenu from "../components/admin_menu";

class OpcionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      alert: "",
      respuesta: "",
      estado: 1,
      orden: 1,
      nombre: "",
      img: "",
      fileOpcion:null,
      fileCustom:null
    };
    //this.enviaDatos = this.enviaDatos.bind(this);
    this.cambia = this.cambia.bind(this);
    this.switchHandle = this.switchHandle.bind(this);
    this.validaForm = this.validaForm.bind(this);
    this.enviaDatos = this.enviaDatos.bind(this);
    this.handleChangeOpcion = this.handleChangeOpcion.bind(this);
    this.handleChangeOpcion = this.handleChangeOpcion.bind(this);
    this.grupoChange = this.grupoChange.bind(this);
    this.uploadImgCustom = this.uploadImgCustom.bind(this)
    this.uploadImgOpcion =this.uploadImgOpcion.bind(this)
  }

  componentDidMount() {
    if (!this.props.usuario.user) {
      this.props.history.push("/login");
    }

    var grupos = this.props.productos.prod.opciones.find((cat, i) => {
      //console.log(cat);
      return cat.id === parseInt(this.props.match.params.cat);
    });

    //console.log(this.props.match.params.id);
    //console.log(this.props.productos.prod);
    if (this.props.match.params.id){

        const categoria = this.props.productos.prod.opciones.find((cat, i) => {
          return cat.id == this.props.match.params.cat;
        });
        
        const opcion = categoria.items.find((opcion, i) => {
          return opcion.id == this.props.match.params.id;
        });
        //console.log(categoria);
        //console.log(opcion)
        var img=null
        if(opcion.hasOwnProperty("img")){
          img=opcion.img
        }
        var orden = 0
        if (opcion.hasOwnProperty("orden")) {
          orden = opcion.orden
        }

        var op = {
          id: opcion.id,
          categoria: categoria,
          nombre: opcion.nombre,
          img: img,
          estado: opcion.estado,
          orden: orden,
          loading: false
        }
        console.log(op)
        this.setState(op);

    }else{
      this.setState({
        loading: false
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.productos.contador > prevProps.productos.contador) {
      this.props.history.push("/admin/producto/" + this.props.productos.prod.id);
    }
  }

  enviaDatos = e => {
    e.preventDefault();
    console.log(this.state)
    this.setState({ loading: true }, () => {
      const valida = this.validaForm();
      if (valida.resp) {
        const o = {
          nombre:this.state.nombre,
          opcion:this.state.opcion,
          orden:this.state.orden,
          estado:this.state.estado
        }
        if (this.props.match.params.id){
          this.props.guardaOpcion(this.props.productos.prod.id, this.props.match.params.id, o);
        }else{
          this.props.guardaOpcion(this.props.productos.prod.id, null, o);
        }
      } else {
        this.setState({ alert: valida.msj, loading: false });
      }
    });
  };

  validaForm = () => {
    if (this.state.nombre == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL NOMBRE"
      };
    } else if (this.state.orden == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL ORDEN"
      };
    } else {
      return {
        resp: true,
        msj: "PASO LA VALIDACION"
      };
    }
  };

  cambia = (key, value) => {
    /*if(key==="provincia"){
            this.props.getCiudades(value)
        }*/
    this.setState({ [key]: value });
  };

  handleChangeOpcion = (file) => {
    console.log(file)
    this.setState({fileOpcion:file})
  }

  handleChangeCustom = (file) => {
    console.log(file);
    this.setState({ fileCustom: file })
  }

  switchHandle = (campo, valor) => {
    this.setState({ [campo]: valor });
  };

  grupoChange(e) {
    const grupoNew = this.props.productos.prod.grupos.find(grupo => {
      return grupo.id == e.target.value;
    })
    //console.log(catNew);
    this.setState({
      opcion: {
        id: grupoNew.id,
        nombre: grupoNew.nombre,
        orden: grupoNew.orden
      }
    });
  }

  uploadImgCustom(){
    if (this.state.fileCustom){
      this.setState({ loading: true, submit: true }, () => {
      this.props.uploadImgCustom(this.props.productos.prod.id, this.props.match.params.id, this.state.fileCustom);
      })
    }
  }

  uploadImgOpcion(){
    if (this.state.fileOpcion) {
      this.setState({ loading: true, submit: true }, () => {
        this.props.uploadImgOpcion(this.props.productos.prod.id,this.props.match.params.cat, this.props.match.params.id, this.state.fileOpcion,this.state.img);
      })
    }
  }

  render() {
    var grupos = null
    if (this.props.productos.prod.hasOwnProperty("grupos")){
      grupos = this.props.productos.prod.grupos.map((grupo, i) => {
        return <option key={i} value={grupo.id}>{grupo.nombre}</option>
      });
    }
    return (
      <section className="container row mb-5 sombraHead mt-3 clearfix">
        <div className="col-md-4 mb-3">
          <AdminMenu />
        </div>

        <div className="col-md-8 mb-3">
          {this.state.alert != "" && (
            <div className="alert alert-danger" role="alert">
              {this.state.alert}
            </div>
          )}

          { this.props.match.params.id &&   
            <section className="row">
              <div className="col-md-6 mb-3">
                <div className="card" style={{ width: "18rem" }}>
                  <img className="card-img-top" src={
                    "https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F" +
                    this.state.img +
                    ".png?alt=media"
                  }
                    alt={this.state.nombre} />
                    <div className="card-body">
                      <h5 className="card-title">IMAGEN OPCION</h5>
                      {!this.state.loading &&
                      <div className="row">
                        <input
                          type="file"
                          className="form-control col"
                          id="opcionImg"
                          onChange={e => this.handleChangeOpcion(e.target.files)}
                        />
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={this.uploadImgOpcion}
                        >
                          <i className="fas fa-angle-right" />
                        </button>
                      </div>
                      }
                    </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="card" style={{width: "18rem"}}>
                  <img className="card-img-top" src={
                    "https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/custom%2F" +
                    this.state.id +
                    ".png?alt=media"
                  }
                    alt={this.state.nombre} />
                  <div className="card-body">
                    <h5 className="card-title">IMAGEN CUSTOM</h5>
                    { !this.state.loading &&
                    <div className="row">
                      <input
                        type="file"
                        className="form-control col"
                        id="customImg"
                        onChange={e => this.handleChangeCustom(e.target.files)}
                      />
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={this.uploadImgCustom}
                      >
                        <i className="fas fa-angle-right" />
                      </button>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </section>
          }

          <hgroup className="row">
            <h1 className="display-4 col">Opcion</h1>
            {!this.state.loading &&
            <div>
              <Link to={"/admin/producto/" + this.props.productos.prod.id} className="btn btn-primary">
                VOLVER
              </Link>
            </div>
            }
          </hgroup>

          <form>
            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label>Nombre</label>
                <input type="text" className="form-control" id="nombre" value={this.state.nombre} aria-describedby="emailHelp" placeholder="Ingrese el nombre del producto" onChange={evt => this.cambia("nombre", evt.target.value)} />
              </div>
              <div className="col-md-6 mb-3">
                <label>Categoria</label>
                <select className="form-control" id="grupo" value={this.state.id_opcion} onChange={this.grupoChange}>
                  <option value="0">SELECCIONAR</option>
                  {grupos}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label>ORDEN</label>
                <input
                  type="number"
                  className="form-control"
                  name="orden"
                  value={this.state.orden}
                  onChange={evt => this.cambia("orden", parseInt(evt.target.value))}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label>ESTADO</label>
                <Switch switchAct={this.switchHandle} dato="estado" off_valor={0} on_valor={1} off="NULO" on="ACTIVO" stat={this.state.estado} />
              </div>
            </div>

            {!this.state.loading ? (
              <button
                type="submit"
                className="btn btn-primary"
                onClick={this.enviaDatos}
              >
                Guardar
              </button>
            ) : (
              <h5>AGUARDE UN INSTANTE...</h5>
            )}
          </form>
          {/*
          <button
            type="submit"
            className="btn btn-primary"
            onClick={this.enviaDatos}
          >
            USAR LA IMAGEN DE ESTA OPCION COMO IMAGEN DEL PRODUCTO
          </button>
          */}
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    usuario: state.usuario,
    productos: state.productos
  };
};

const mapDispatchToProps = dispatch => {
  return {
    uploadImgCustom: (id_producto, id_opcion, file) => {
      dispatch(uploadImgCustom(id_producto, id_opcion, file));
    },
    uploadImgOpcion: (id_producto, id_grupo, id_opcion, imgActual, file) => {
      dispatch(uploadImgOpcion(id_producto,id_grupo, id_opcion, imgActual, file));
    },
    guardaOpcion: (id_producto, id_opcion, datos) => {
      dispatch(guardaOpcion(id_producto, id_opcion, datos));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpcionForm);



// WEBPACK FOOTER //
// ./src/containers/admin_opcion_form.js